import TemplateNames from '../email-messages/TemplateNames';

export default {
  template_names: TemplateNames,
  email_messages_page_title: 'E-Mail-Nachrichten',
  labels: {
    view_full_message: 'Vollständige Nachricht anzeigen',
    status: 'Status:',
    on: 'An',
    off: 'Aus',
  },
  tiles: {
    sends_count: 'Nachrichten gesendet',
    delivery_rate: 'Zustellungsrate',
    delivered_suffix: 'zugestellt',
    open_rate: 'Öffnungsrate',
    opened_suffix: 'geöffnet',
    click_rate: 'Klickrate',
    clicked_suffix: 'geklickt',
    spam_report_rate: 'Spam-Report-Rate',
    spam_reports_suffix: 'Berichte',
    unsubscribe_rate: 'Abmelderate',
    unsubscribes_suffix: 'Abmeldungen',
  },
  toasts: {
    failed_to_update_status: 'Status konnte nicht aktualisiert werden',
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },

  preview_modal: {
    title: 'Vorschau des Templates',
    labels: {
      subject: 'Betreff:',
      close: 'Schließen',
    },
    toasts: {
      failed_to_load_data: 'Vorschau-Daten konnten nicht geladen werden',
    },
    template_data: {
      recipient_name: '&lt;Vorname&gt;',
    },
  },
};
